import { IGetComplaintReplies } from "../../utils/types";
import { apiManager } from "../api-manager";

export const getComplaintRepliess = async (
  complaintId: string,
  params?: { sort?: string; page?: number }
) => {
  const res = await apiManager.get<IGetComplaintReplies>(
    `/helpdesk/get-messages/${complaintId}`,
    params
  );

  return res;
};
